import type { WithRequired } from '../../common/utilities.ts';
import type { Identity, PeerId, Restrictions } from './common.ts';
import { DomainKeys, type Options } from './state.ts';
import type { Immutable } from 'immer';

export const contextDomain = DomainKeys.Context;
export type ContextId = string;
export type Lifetime = 'ref-counted' | 'ownership' | 'retained' | 'activity';
export type Version = Immutable<{ updates: number, timestamp: number }>;
export type ContextData = Immutable<{ [name: string]: unknown }>;
export type Context = Immutable<{
    id: ContextId,
    lifetime: Lifetime,
    members: Set<PeerId>
    creator: PeerId
    identity: Identity
    name?: string
    // request permissions
    read_permissions?: string
    write_permissions?: string,
    // resolved permissions
    permissions?: { read: Restrictions, write: Restrictions },
    data?: ContextData
    owner?: PeerId
    version?: Version
    local?: boolean
    options?: Options
}>;

export type ContextDomain = {
    restrictions: Restrictions
};

export type VersionedContext = WithRequired<Context, 'version'>;
